import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { UmbracoTypes } from '~/lib/data-contract';
import { useFilterResults } from '~/services/loop54/hooks';
import { useFilterDefaults, usePage } from '~/services/umbraco/hooks';
import { useUrlQueryState } from '~/shared/hooks';
import { getFilterQuery } from '~/shared/utils/helpers';
import usePaging from './usePaging';

export default function useFilter(displayCategoryPath?: boolean) {
    const { isReady } = useRouter();
    const [filtersFromUrl, setUrlFilter] = useUrlQueryState();
    const [pageNumber] = usePaging();
    const { data: page } = usePage<UmbracoTypes.IP40ProductListPage>();
    const { data: filterDefaults } = useFilterDefaults();

    const params = getFilterQuery({
        displayCategoryPath,
        filterAdmin: page?.pageProperties?.filterAdmin,
        filterDefaults,
        filtersFromUrl,
        pageNumber,
        pageTitle: page?.title,
        breadcrumb: page?.breadcrumb,
    });

    const results = useFilterResults(params);
    const selectedContext = filtersFromUrl?.ContextGroup?.[0];
    const shouldSetContextGroup =
        results?.data?.customData?.selectedContext &&
        // @ts-ignore - generated loop54 types are wrong
        (results.data.customData.contextGroups as []).length > 1 &&
        results.data.customData.selectedContext !== 'none' &&
        !selectedContext;

    useEffect(() => {
        if (isReady && shouldSetContextGroup) {
            setUrlFilter('ContextGroup', [results!.data!.customData!.selectedContext as string]);
        }
    }, [isReady, results, setUrlFilter, shouldSetContextGroup]);

    return results;
}
